module.exports = "<p>offline-quote works!</p>\n"